import { _Base } from "../_Base";
import { endpoints } from "../endpoints";

export class Legacy extends _Base {
  endPointRoot = process.env.REACT_APP_ROOT_T_REST_API_MICRO;
  STATUS_SUCCESS = "OK";
  JSESSIONID: string | null = null;

  constructor(jsessionId: string) {
    super();
    this.JSESSIONID = jsessionId;
  }

  getFolders = async () => {
    const url = `${this.endPointRoot}${endpoints["api-micro"].listFolders}`;
    const response = await this.prepareGet(url, null, {
      jsessionid: this.JSESSIONID,
    });
    if (response.status !== this.STATUS_SUCCESS) {
      throw new Error("Error fetching folders");
    }

    return response.data.folders;
  };

  getFilesFromFolder = async (folder: string) => {
    const url = `${this.endPointRoot}${endpoints["api-micro"].listFiles}`;
    const response = await this.prepareGet(
      url,
      {
        folder: folder,
      },
      {
        jsessionid: this.JSESSIONID,
      }
    );
    if (response.status !== this.STATUS_SUCCESS) {
      throw new Error("Error fetching files");
    }
    return response.data.list;
  };

  getFiles = async () => {
    const url = `${this.endPointRoot}${endpoints["api-micro"].listFiles}`;
    const response = await this.prepareGet(url, null, {
      jsessionid: this.JSESSIONID,
    });
    if (response.status !== this.STATUS_SUCCESS) {
      throw new Error("Error fetching files");
    }
    return response.data.list;
  };

  uploadFile = async (file: File, folder: string) => {
    const url = `${this.endPointRoot}${endpoints["api-micro"].uploadFile}`;
    const formData = new FormData();
    formData.append("file", file);
    formData.append("folder", folder);
    const response = await this.preparePost(url, formData, {
      "Content-Type": "multipart/form-data",
      jsessionid: this.JSESSIONID,
    });
    if (response.status !== this.STATUS_SUCCESS) {
      throw new Error("Error uploading file");
    }
    return response.data;
  };

  deleteFile = async (fileName: string) => {
    const url = `${this.endPointRoot}${endpoints["api-micro"].deleteFile}`;
    const response = await this.preparePost(
      url,
      { fileName: fileName },
      {
        jsessionid: this.JSESSIONID,
      }
    );
    if (response.status !== this.STATUS_SUCCESS) {
      throw new Error("Error deleting file");
    }
    return response.data;
  };

  // --------------------------------------------------- RAG ingestion (ai-agent)
  // These endpoints hit the server-ai-agent directly: the response is a plain
  // JSON body (no { status: "OK", data } envelope) and errors surface as axios
  // rejections on non-2xx (202 started / 409 running / 400 bad request). Auth is
  // the raw JSESSIONID in the Authorization header, with NO Bearer prefix.

  getRagStatus = async () => {
    const url = `${this.endPointRoot}${endpoints["api-micro"].ragStatus}`;
    // → { running, progress?, lastReport }
    return await this.prepareGet(url, null, {
      Authorization: this.JSESSIONID,
    });
  };

  syncRag = async () => {
    const url = `${this.endPointRoot}${endpoints["api-micro"].ragSync}`;
    return await this.preparePost(url, null, {
      Authorization: this.JSESSIONID,
    });
  };

  wipeRag = async () => {
    // confirm=WIPE is a mandatory query param; append it to the URL (preparePost
    // also adds its own `ts` param, axios merges both into the query string).
    const url = `${this.endPointRoot}${endpoints["api-micro"].ragWipe}?confirm=WIPE`;
    return await this.preparePost(url, null, {
      Authorization: this.JSESSIONID,
    });
  };
}
